module.exports = __webpack_public_path__ + "static/desktop-services-c577ad16be8bd1ff1b5d5f38b8aa9d64.png";